import { post } from 'vio-libs';
export function postAdditionalPortRequest(organization, location, portCount) {
    return post(`additional-port-request?organization=${organization}`, {
        data: {
            location,
            port_count: portCount
        }
    });
}
